var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.06929 9.7803C5.75897 10.0732 5.25584 10.0732 4.94553 9.7803L0.442697 5.53033C0.132382 5.23744 0.132382 4.76256 0.442697 4.46967L4.94553 0.219668C5.25584 -0.0732225 5.75897 -0.0732225 6.06929 0.219668C6.37958 0.512558 6.37958 0.987438 6.06929 1.28033L2.12833 5L6.06929 8.7197C6.37958 9.0126 6.37958 9.4874 6.06929 9.7803Z",
    fill: "#C7CCD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left_arrow.266c2d80b7bcd8d044c87a24f442656f.svg";
export { ForwardRef as ReactComponent };